import React from 'react';
import Tooltip from 'components/formElements/Tooltip';


const Label = (props) => {
    return (
        <div className={["Label", props.className].join(" ")}>{props.text}{props.info && <Tooltip label={props.info} />}</div>
    );
}

export default Label;